<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <!--头部导航-->
    <breadCrum :breadCrumList="breadCrumList"></breadCrum>
    <div class="w80 fsb mt-30 mb-46">
      <!--左边-->
      <div style="width: 66%">
        <p class="detail_title">
          {{ dataInfo.projectName }}
        </p>
        <div class="detail_box mt-20">
          
          <div>
              <table style="width: 100%">
                  <tr>
                      <th>项目编号</th>
                      <th>项目版本</th>
                      <th>当前阶段</th>
                  </tr>
                  <tr>
                      <td v-if="dataInfo.itemOn">{{dataInfo.itemOn}}</td><td class="buy" v-else>购买后查看</td>
                      <td v-if="dataInfo.persionVersion">{{dataInfo.persionVersion}}</td><td class="buy" v-else>购买后查看</td>
                      <td v-if="dataInfo.stage">{{dataInfo.stage}}</td><td class="buy" v-else>购买后查看</td>
                  </tr>
                  <tr>
                      <th>所属行业</th>
                      <th>业主类型</th>
                      <th>项目权重</th>
                  </tr>
                  <tr>
                      <td v-if="dataInfo.industryType">{{dataInfo.industryType}}</td><td class="buy" v-else>购买后查看</td>
                      <td v-if="dataInfo.ownerType">{{dataInfo.ownerType}}</td><td class="buy" v-else>购买后查看</td>
                      <td v-if="dataInfo.weight">{{dataInfo.weight}}</td><td class="buy" v-else>购买后查看</td>
                  </tr>
                  
                  <tr>
                      <th>工程类型</th>
                      <th>采购情况</th>
                      <th>竣工时间</th>
                  </tr>
                  <tr>
                      <td v-if="dataInfo.projectType">{{dataInfo.projectType}}</td><td class="buy" v-else>购买后查看</td>
                      <td v-if="dataInfo.procurement">{{dataInfo.procurement}}</td><td class="buy" v-else>购买后查看</td>
                      <td v-if="dataInfo.completionTime">{{formateTime(dataInfo.completionTime)}}</td><td class="buy" v-else>购买后查看</td>
                  </tr>
                  
                  <tr>
                      <th>所在区域</th>
                      <th>省份/城市</th>
                      <th>占地面积</th>
                  </tr>
                  <tr>
                      <td v-if="dataInfo.areaName">{{dataInfo.areaName}}</td><td class="buy" v-else>购买后查看</td>
                      <td v-if="dataInfo.city">{{dataInfo.city}}</td><td class="buy" v-else>购买后查看</td>
                      <td v-if="dataInfo.floorSpace">{{dataInfo.floorSpace}}</td><td class="buy" v-else>购买后查看</td>
                  </tr>
                  <tr>
                      <th>投资金额</th>
                      <th>资金状况</th>
                      <th>发布日期</th>
                  </tr>
                  <tr>
                      <td v-if="dataInfo.investmentAmount">{{dataInfo.investmentAmount}}</td><td class="buy" v-else>购买后查看</td>
                      <td v-if="dataInfo.financialConditions">{{dataInfo.financialConditions}}</td><td class="buy" v-else>购买后查看</td>
                      <td v-if="dataInfo.releaseTime">{{formateTime(dataInfo.releaseTime)}}</td><td class="buy" v-else>购买后查看</td>
                  </tr>
              </table>
          </div>
          <div class="fdc mt-30">
            <user-operation
              v-if="dataInfo.title"
              class="user_operation"
              :shareObj="dataInfo"
              :notStatus="status"
              @onCollection="goCollection()"
              @callCollection="callCancelcollection()"
            ></user-operation>
            <!-- <div class="fdc">
              <div
                v-if="buy == true"
                class="middle_box mr-10 background_1"
                @click="goBuy()"
              >
                我要购买
              </div>
              <div
                v-if="buy == true && dataInfo.integral"
                class="middle_box mr-10 background_1"
                @click="goBuy(0)"
              >
                积分兑换
              </div>
              <div
                v-if="notBuy == true"
                class="middle_box background_2"
                @click="toDowload"
              >
                下载
              </div>
            </div> -->
          </div>
        </div>

        <div>
            <P style="margin-top:20px">建设单位概况</P>
            <div>
                 <div v-if="!dataInfo.unitOverview" class="broundMsgImg">
                     <p style="margin-top: 8%;text-align: center;">购买后查看本页所有隐藏信息</p>
                     <div class="buyMsg">
                        <p @click="toBuy(1)">余额购买：￥{{dataInfo.projectAmount}} >></p>
                        <P @click="toBuy(0)">积分抵扣：{{dataInfo.projectIntegral}}积分 >></P>
                     </div>
                 </div>
                 <div
                    v-if="dataInfo.unitOverview"
                    class="dataDetailContanier box_text mt-20"
                    v-html="keepTextStyle(dataInfo.unitOverview)"
                ></div>
                <img v-else class="bround" src="https://zhiwubang-oss.oss-cn-beijing.aliyuncs.com/upload/20220302/60359389d3f5482eb57897b920ba2d7e.png"/>
            </div>
        </div>

        <div>
            <P style="margin-top:20px">项目详情介绍</P>
             <div>
                 <div v-if="!dataInfo.projectDetails" class="broundMsgImg">
                     <p style="margin-top: 8%;text-align: center;">购买后查看本页所有隐藏信息</p>
                     <div class="buyMsg">
                        <p @click="toBuy(1)">余额购买：￥{{dataInfo.projectAmount}} >></p>
                        <P @click="toBuy(0)">积分抵扣：{{dataInfo.projectIntegral}}积分 >></P>
                     </div>
                 </div>
                 <div
                    v-if="dataInfo.projectDetails"
                    class="dataDetailContanier box_text mt-20"
                    v-html="keepTextStyle(dataInfo.projectDetails)"
                    ></div>
                <img v-else class="bround" src="https://zhiwubang-oss.oss-cn-beijing.aliyuncs.com/upload/20220302/60359389d3f5482eb57897b920ba2d7e.png"/>
            </div>
        </div>

         <div>
            <P style="margin-top:20px">项目进度建设说明</P>
            <div>
                 <div v-if="!dataInfo.progress" class="broundMsgImg">
                     <p style="margin-top: 8%;text-align: center;">购买后查看本页所有隐藏信息</p>
                     <div class="buyMsg">
                        <p @click="toBuy(1)">余额购买：￥{{dataInfo.projectAmount}} >></p>
                        <P @click="toBuy(0)">积分抵扣：{{dataInfo.projectIntegral}}积分 >></P>
                     </div>
                 </div>
                  <div
                    v-if="dataInfo.progress"
                    class="dataDetailContanier box_text mt-20"
                    v-html="keepTextStyle(dataInfo.progress)"
                    ></div>
                <img v-else class="bround" src="https://zhiwubang-oss.oss-cn-beijing.aliyuncs.com/upload/20220302/60359389d3f5482eb57897b920ba2d7e.png"/>
            </div>
        </div>

        <div>
            <P style="margin-top:20px">特殊说明</P>
             <div>
                 <div v-if="!dataInfo.specialInstructions" class="broundMsgImg">
                     <p style="margin-top: 8%;text-align: center;">购买后查看本页所有隐藏信息</p>
                     <div class="buyMsg">
                        <p @click="toBuy(1)">余额购买：￥{{dataInfo.projectAmount}} >></p>
                        <P @click="toBuy(0)">积分抵扣：{{dataInfo.projectIntegral}}积分 >></P>
                     </div>
                 </div>
                  <div
                    v-if="dataInfo.specialInstructions"
                    class="dataDetailContanier box_text mt-20"
                    v-html="keepTextStyle(dataInfo.specialInstructions)"
                ></div>
                <img v-else class="bround" src="https://zhiwubang-oss.oss-cn-beijing.aliyuncs.com/upload/20220302/60359389d3f5482eb57897b920ba2d7e.png"/>
            </div>
        </div>


        <!-- <pdf-loader v-if="readFile" :src="readFile"></pdf-loader>
        <div class="box_coment">
          <button  v-if="buy == true"   @click="toBuy">继续阅读</button>
        </div> -->
      </div>
      <!--右边-->
      <div class="detali_right">
        <div class="cox_fwer fdc">
          <p>推荐资料</p>
          <p class="refresh_btn fdc">
            <img class="mr-8" src="../../assets/images/break.png" alt="" />
            <span class="cox_text" @click="getRandomList(3)">换一批</span>
          </p>
        </div>
        <div
          class="cox_banter"
          @click="goToDetail(item)"
          v-for="(item, index) in recommendList"
          :key="index"
        >
          <img :src="item.covers" alt="" />
          <div class="cox_conter">
            <p class="cox_title">{{ item.title }}</p>
            <p class="mt-20">
              <span>观看人数：{{ item.visitcount }}</span>
            </p>
          </div>
        </div>
      </div>
    </div>
      <!--弹框登录-->
    <loginDialog :dialogVisible.sync="dialogVisible"></loginDialog>
  </div>
</template>
<script>
import { dateFormat } from '@/utils';
import {
  addCollection,
  createorder,
  getorderstatus,
  download,
  alreadypurchase,
  iscollection,
  cancelcollection,
  addBrowse
} from "@/api/coment";
import {routerGoNewpage,getRandomArray } from "@/utils/index"
import {
  getDataList,
  getDataDetailById,
  getDataCenterFile,
} from "../../api/information";
import { userAuth } from "@/api/my";
import commBanner from "../../common/commBanner";
import contTitle from "../../common/contTitle";
import userOperation from "../../common/userOperation";
import { getToken } from "@/utils/auth";
import retrieveVue from "../retrieve.vue";
import breadCrum from "@/common/breadCrum";
import pdfLoader from "@/common/pdfLoader";
import loginDialog from "../../components/loginDialog"
import { projectInfo } from "@/api/coment"
export default {
  components: { commBanner, contTitle, userOperation, breadCrum, pdfLoader,loginDialog },
  data() {
    return {
      obj: {
        title: "资料详情",
        contCount: "",
        isColor: false,
        roleType: "",
        personalType: 4,
      },
      breadCrumList: [
        { name: "项目信息", url: "/supply_project" },
        { name: "", url: "" },
      ],
      dataInfo: [],
      recommendList: [],
      allList: [],
      active: true,
      orderNo: "", //订单编号
      status: false,
      buy: false,
      notBuy: false,
      fileShow: false,
      readFile: "",
      dialogVisible: false,
      // purchase:false  //继续阅读
      tableData:[{
            date: 'HQ20220318',
            name: '版本1',
            address: '阶段1'
          }]
    };
  },
  created() {
    this.getDataDetailById();
    this.getRecommendDataList();
    this.getDataCenterFile();
    if (this.$store.state.user.userInfo != null) {
      let type = this.$store.state.user.userInfo.type;
      this.obj.roleType = type;
    }
    if (getToken() != undefined) {
      this.getAlreadypurchase();
      this.getIscollection();
      this.getAddBrowse();
    } else {
      this.buy = true;
    }
  },
  watch: {
    $route: {
      handler: function (route) {
        //this.getDataDetailById();
      },
      immediate: true,
    },
  },
  methods: {
    formateTime(data){
      let date = new Date(data)
      return dateFormat(date,'YYYY-MM-dd')
    },
    showFile() {
      if (!this.readFile) {
        this.$message({
          message: "没有可以预览的文件！",
          type: "info",
          duration: 1000,
        });
        return;
      }
      this.fileShow = !this.fileShow;
    },
    //获取试读文件
    getDataCenterFile() {
      getDataCenterFile({ id: this.$route.query.id }).then((res) => {
        if ( res && undefined!= res.code &&  res.code == 0 &&  res.data) {
          this.readFile = res.data;
        }
      });
    },
    //资料详情
    getDataDetailById() {
      projectInfo({ id: this.$route.query.id })
        .then((res) => {
          if (res.code == 0) {
            this.dataInfo = res.data;
            this.getMate(res.data);
            // this.dataInfo.content = this.dataInfo.content.replace(
            //   /<img/g,
            //   "<img style='width:100%;height:auto;'"
            // );
            this.breadCrumList[1].name = res.data.projectName;
          }
        })
        .catch((err) => {});
    },
    goToDetail(item) {
      routerGoNewpage("/data_detail",{id:item.id})
      // this.$router.push({
      //   path: "/data_detail",
      //   query: {
      //     id: item.id,
      //   },
      // });
    },
    goBuy(patterns){
     if(getToken() == undefined){
       this.dialogVisible = !this.dialogVisible;
     }else{
       if(this.dataInfo.fileprice>0){
          this.$confirm('确认要购买吗?','提示',{
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then((res)=>{
              this.toBuy(patterns);
          }).catch((err)=>{
            this.$message({
              type: 'info',
              message: '已取消购买'
            });
          })
       }else{
         this.toBuy(patterns);
       }
     }
    },

    //前往购买页面
    toBuy(patterns) {
      let postData = {
        amount: this.dataInfo.projectAmount,
        goodsId: this.$route.query.id,
        goodsType: 12,
        buyPatterns: patterns
      };
      createorder(postData)
        .then((res) => {
          this.orderNo = res.data.orderNo;
          if (res.code == 0) {
            localStorage.setItem("list", JSON.stringify(res.data));
            localStorage.setItem("title", this.dataInfo.projectName);
            if (res.data.status == 1) {
              this.$message({
                message: "购买成功!",
                type: "success",
                duration: 1000,
              });
              location.reload();
              this.notBuy = true;
              this.buy = false;
              this.purchase = false;
            } else {
              let url = window.location.href.split("//")[1];
              let host = window.location.host;
              let str = url.replace(host,"");
              str = str.substring(1);
              sessionStorage.setItem('url',str);
              this.$router.push({
                name: "payment_information"
              });

            }
          }
        })
        .catch((err) => {});
    },
    //获取推荐资料列表 前端随机取4个
    getRecommendDataList() {
      getDataList({
        recommend: 1,
      }).then((res) => {
        if(res.code == 0){
         this.allList = res.page.list;
         this.getRandomList(3);
        }
      });
    },
    getRandomList(length) {
      this.recommendList = _.compact(
        getRandomArray(_.cloneDeep(this.allList), length)
      );
    },
    //资料收藏
    goCollection() {
      this.active = 1;
      let params = {
        goodsId: this.$route.query.id,
        goodsType: 1,
      };
      addCollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.$message({
              message: "收藏成功！",
              type: "success",
              duration: 1000,
            });
          }
        })
        .catch((err) => {});
    },
    //取消收藏
     callCancelcollection(){
       let params = {
          goodsid:this.$route.query.id,
          goodstype:"1"
       }
       cancelcollection(params).then((res)=>{
         if(res.code == 0){
            this.$message({
              type:"success",
              message:"取消收藏"
            })
         }
       }).catch((err)=>{})
     },
    //查询购买状态
    getorderstatus() {
      let postData = {
        OrderNo: this.orderNo,
      };
      getorderstatus(postData)
        .then((res) => {
          if (re.code == 0) {
            if (res.data.status == 1) {
              this.show = true;
            }
          }
        })
        .catch((err) => {});
    },
    //下载
    toDowload() {
      this.getorderstatus();
      let postData = {
        goodstype: 1,
        goodsid: this.$route.query.id,
      };
      download(postData)
        .then((res) => {
          if (res.code == 0) {
            window.location.href = res.url;
          } else {
            this.$message.err(res.msg);
          }
        })
        .catch((err) => {});
    },
    //查看收藏状态
    getIscollection() {
      let params = {
        goodsid: this.$route.query.id,
        goodstype: 1,
      };
      iscollection(params)
        .then((res) => {
          if (res.code == 0) {
            this.status = res.data;
          }
        })
        .catch((err) => {});
    },
    //查询资源是否已购买
    getAlreadypurchase() {
      let params = {
        goodstype: 1,
        goodsid: this.$route.query.id,
      };
      alreadypurchase(params)
        .then((res) => {
          if (res.data == true) {
            this.notBuy = true;
          } else {
            this.buy = true;
          }
        })
        .catch((err) => {});
    },
    keepTextStyle(val) {
      return (val + "").replace(/(<br[^>]*>|\s*)/g, "");
    },
    getMate(data) {
      var metas = document.getElementsByTagName("meta");
      metas[0].name = "keyword";
      metas[0].content = data.seokeywords;
      metas[1].name = "description";
      metas[1].content = data.seodescription;
      document.getElementsByTagName("title")[0].innerText = data.projectName +'_智污邦环保服务平台';
    },
    //浏览数增加
    getAddBrowse(){
      let postData ={
        goodsId:this.$route.query.id,
        goodsType:1,
        id:this.$store.state.user.userInfo.data.userId
      };
      addBrowse(postData).then((res)=>{
        if(res.code == 0){}
      }).catch((err)=>{})
    }
  },
};
</script>
<style scoped>
.content {
  margin-top: 10px;
  border-bottom: 1px solid #dcdcdc;
  margin-bottom: 30px;
  width: 100%;
}
.breadcrum {
  display: flex;
  align-items: center;
  margin: 0 auto;
  height: 30px;
  line-height: 30px;
  padding-bottom: 10px;
  /* width: 78%; */
  /* margin-left: 10%; */
}
.breadcrum span {
  padding: 0px 5px;
  color: #9a9a9a;
}
.breadcrum a {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9a9a9a;
}
.breadcrum a.host {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}

.fsb {
  display: flex;
  justify-content: space-between;
}
.f1 {
  flex: 1;
}
.ml-5 {
  margin-left: 5px;
}
.mt-10 {
  margin-top: 10px;
}
.mr-8 {
  margin-right: 8px;
}
.mt-20 {
  margin-top: 20px;
}
.ml-30 {
  margin-left: 30px;
}
.ml-35 {
  margin-left: 35px;
}
.mr-10 {
  margin-right: 10px;
}
.mr-40 {
  margin-right: 40px;
}
.mb-46 {
  margin-bottom: 46px;
}
.detail_title {
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.detail_box {
  width: 100%;
  /* height: 182px; */
  height: 305px;
  background: #ffffff;
  border: 1px solid #eeeeee;
  padding: 20px 30px;
}
.box_text span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.box_text span.sign {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ff7302;
}
.box_text span.price {
  font-size: 30px;
  font-family: Arial;
  font-weight: 400;
  color: #ff7302;
  color: #ff7302;
}
.stars {
  width: 19px;
  height: 18px;
  vertical-align: middle;
}
.icon {
  width: 20px;
  height: 19px;
  margin-right: 20px;
  vertical-align: middle;
}
.middle_box {
  cursor: pointer;
  width: 114px;
  height: 35px;
  line-height: 35px;
  text-align: center;

  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.background_1 {
  background: #ff7302;
}
.background_2 {
  background: #f6bc20;
}
.box_text {
  flex: 1;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 24px;
  display: flex;
  /* align-items: center; */
}
.dataDetailContanier {
  margin-bottom: 40px;
  display: flex;
  flex-direction: column;
}
/deep/.dataDetailContanier p{
 text-align: left;
}
.box_img img {
  width: 100%;
}
.box_coment {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 46px;
}
.box_coment button {
  width: 114px;
  height: 35px;
  background: #68be31;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}

.detali_right {
  border-top: 2px solid #99cf2a;
  height: 453px;
  background: #f8f8f8;
  width: 30%;
}
.cox_fwer {
  margin: 18px 18px;
}
.refresh_btn {
  cursor: pointer;
}
.cox_fwer p:nth-child(1) {
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
}
.cox_fwer img {
  width: 17px;
  height: 17px;
}
.cox_text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.cox_banter {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  margin: 18px 18px;
}
.cox_banter img {
  width: 113px;
  height: 113px;
}
.cox_conter {
  flex: 1;
  margin-left: 15px;
}
.cox_title{
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000000;
  line-height: 26px;
  width: 100%;
  overflow:hidden;
  text-overflow:ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 2;
  max-height: 77px;
}
.cox_conter p:nth-child(2) {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.box_fileauthor{
  display: inline-block;
  width: 150px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
td{
    width: 30%;
    border-style: dashed;
    border-width: 1px;
    border-color: #ccc;
    text-align: center;
}
th{
    width: 30%;
    border-style: dashed;
    border-width: 1px;
    border-color: #ccc;
    text-align: center;
}
.buy{
    width: 30%;
    border-style: dashed;
    border-width: 1px;
    border-color: #ccc;
    text-align: center;
    color:blue;
}
.bround{
    width: 100%;
    filter: blur(13px);
}
.broundMsgImg{
    width: 350px;
    height: 150px;
    background-color: aqua;
    z-index: 2;
    position: absolute;
    margin-top: 5%;
    margin-left: 11%;
    border-radius: 40px;
}
.buyMsg{
    margin-top: 4%;
    text-align: center;
    color: blue;
}
</style>



// WEBPACK FOOTER //
// src/view/supply_demand/project_detail.vue